import React from 'react'
import Badge from '../Badge/Badge.component'
import type { SchedulerAppointmentInfo } from './Scheduler.types'

type SchedulerAppointmentInfoPanelProps = {
  info: SchedulerAppointmentInfo
  darkMode?: boolean
  style?: React.CSSProperties
  onClose?: () => void
  onMouseEnter?: React.MouseEventHandler<HTMLDivElement>
  onMouseLeave?: React.MouseEventHandler<HTMLDivElement>
}

const Row: React.FC<{
  label: string
  children: React.ReactNode
}> = ({ label, children }) => (
  <div className="ds-scheduler-info__row">
    <span className="ds-scheduler-info__label">{label}</span>
    <span className="ds-scheduler-info__value">{children}</span>
  </div>
)

const SchedulerAppointmentInfoPanel: React.FC<
  SchedulerAppointmentInfoPanelProps
> = ({
  info,
  darkMode = false,
  style,
  onClose,
  onMouseEnter,
  onMouseLeave,
}) => (
  <div
    className={`ds-scheduler-info${darkMode ? ' ds-scheduler-info--dark' : ''}`}
    style={style}
    role="dialog"
    aria-label="Appointment Info"
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    <div className="ds-scheduler-info__header">
      <h4 className="ds-scheduler-info__title">Appointment Info</h4>
      {onClose ? (
        <button
          type="button"
          className="ds-scheduler-info__close"
          aria-label="Close appointment info"
          onClick={onClose}
        >
          ×
        </button>
      ) : null}
    </div>

    <div className="ds-scheduler-info__body">
      <Row label="Patient name:">{info.patientName}</Row>
      <Row label="Provider:">{info.provider || '-'}</Row>
      <Row label="Clinic:">{info.clinic || '-'}</Row>
      <Row label="Procedure:">{info.procedure || '-'}</Row>
      <Row label="Date & Time:">{info.dateTime || '-'}</Row>
      <Row label="Status:">
        {info.status ? (
          <Badge
            label={info.status}
            mode="tinted"
            color={info.statusColor ?? 'pale-green'}
            darkMode={darkMode}
          />
        ) : (
          '-'
        )}
      </Row>
      <Row label="Pref. Dentist:">{info.preferredDentist || '-'}</Row>
      <Row label="Pref. Hygienist:">{info.preferredHygienist || '-'}</Row>
      <Row label="Is Insured:">
        <span className="ds-scheduler-info__linkish">
          {info.isInsured || '-'}
        </span>
      </Row>
      <Row label="Conditions:">{info.conditions || '-'}</Row>
      <Row label="Note:">
        <span className="ds-scheduler-info__linkish">{info.note || '-'}</span>
      </Row>
      <Row label="Pre-auth status:">
        {info.preAuthStatus ? (
          <Badge
            label={info.preAuthStatus}
            mode="tinted"
            color={info.preAuthColor ?? 'yellow'}
            darkMode={darkMode}
          />
        ) : (
          '-'
        )}
      </Row>
    </div>
  </div>
)

export default SchedulerAppointmentInfoPanel
